import React from 'react';
import { Box, Typography } from '@mui/material';
import { Google, CloudQueue as Amazon, CloudDone, Cloud } from '@mui/icons-material';

/**
 * RepositoryTypeDisplay Component
 * 
 * A reusable component to display repository type with icon and name
 * 
 * @param {string} type - The repository type ('gcs', 's3', 'azure')
 * @param {object} sx - Additional Material-UI sx styling props
 * @param {string} iconSize - Icon font size (default: '0.875rem')
 * @param {string} variant - Typography variant (default: 'caption')
 * @param {number} fontWeight - Font weight (default: 600)
 * @param {boolean} showIcon - Whether to show the icon (default: true)
 * @param {boolean} showText - Whether to show the text (default: true)
 */
const RepositoryTypeDisplay = ({ 
    type, 
    sx = {}, 
    iconSize = '0.875rem', 
    variant = 'caption', 
    fontWeight = 600,
    showIcon = true,
    showText = true
}) => {
    if (!type) return '-';

    let IconComponent, displayName;

    switch (type.toLowerCase()) {
        case 'gcs':
            IconComponent = Google;
            displayName = 'Google Cloud Storage';
            break;
        case 's3':
            IconComponent = Amazon;
            displayName = 'AWS S3 Bucket';
            break;
        case 'azure':
            IconComponent = CloudDone;
            displayName = 'Azure Blob';
            break;
        default:
            IconComponent = Cloud;
            displayName = type;
    }

    return (
        <Box sx={{ ...sx }}>
            {showIcon && (
                <IconComponent sx={{ fontSize: iconSize, mr: showText ? 1 : 0 }} />
            )}
            {showText && (
                <Typography variant={variant} fontWeight={fontWeight}>
                    {displayName}
                </Typography>
            )}
        </Box>
    );
};

export default RepositoryTypeDisplay;

